export default __webpack_public_path__ + "static/media/refresh.8a0015a6.svg";